import { bannersPath } from '../Assets/Banners/banners-path'

import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

export default function CarouselSection() {
  return (
    <Carousel
      autoPlay
      infiniteLoop
      interval={4000}
      showArrows={true}
      onSwipeStart={e => {
        e.preventDefault()
      }}
      showIndicators={false}
      showStatus={false}
      showThumbs={false}
      emulateTouch={true}
      width="100%"
    >
      {/* renderização de todos os banners da pasta Assets */}
      {bannersPath.map(banner => {
        return (
          <div draggable>
            <img alt={banner} src={banner} />
          </div>
        )
      })}
    </Carousel>
  )
}
